import { notification } from 'antd'
import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
import constants from '../constants'
import { isAuthenticated } from '../utils/authSession'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('apps init')
}

export async function list(pageNo = 1, searchText = '', roleFilterList = '', planFilter = '') {
  if (isAuthenticated()) {
    return axios
      .get(
        `${constants.customerDomain}apps?per_page=${constants.perPageAppsListing}&page=${pageNo}&searchKey=${searchText}&roles=${roleFilterList}&plan=${planFilter}`,
      )
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        } else {
          notification.error({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function get(id) {
  return axios
    .get(`${constants.customerDomain}apps/${id}?includeParentApp=1`)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }

      if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      } else if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        let errorMsgs = handleErrors('')
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      }
      // } else {
      //   notification.error({
      //     message: 'Network Error',
      //     description: 'Seems to be a network error or a request timeout. Please try again.',
      //   })
      // }
      return errorObj
    })
}

export async function add(post) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps`, post)
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_CREATION_FAILED'
        ) {
          notification.error({
            message: 'App Creation Failed!',
            description:
              'Failed to create a new app. Please try again, contact CometChat Team if error persists.',
          })
        } else if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function update(id, post) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .put(`${ACTION_URL}apps/${id}`, post)
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_NOT_FOUND'
        ) {
          notification.error({
            message: 'App Not Found!',
            description: error.response.data.error.message,
          })
        } else if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_ACCESS_DENIED'
        ) {
          notification.error({
            message: 'Access denied',
            description:
              'You are not authorized to change app settings. Please contact your app owner',
          })
        } else if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        // } else {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function del(id, app) {
  if (isAuthenticated()) {
    let ACTION_URL
    if (app.region === 'legacy') {
      ACTION_URL = constants.customerDomain
    } else {
      ACTION_URL = constants.customerDomain
    }
    const data = {
      permanent: true,
    }
    return axios
      .delete(`${ACTION_URL}apps/${id}`, {
        data,
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        // } else if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsUpdate(id, post, app, apiHost) {
  if (isAuthenticated() && app.region === 'legacy') {
    const URL = `${getChatApiBase(app, apiHost)}/settings`

    return axios
      .put(`${URL}`, post, {
        headers: { ...getChatApiHeaders(app), appId: id },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        // if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsGet(id, app) {
  if (isAuthenticated()) {
    const URL = `${getChatApiBase(app, app.appRegion.meta.apiHost)}/settings`

    return axios
      .get(`${URL}`, {
        headers: { ...getChatApiHeaders(app), appId: id },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        // if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsThreadAndConversationGet(id) {
  if (isAuthenticated()) {
    return axios
      .get(`${constants.customerDomain}apps/${id}/settings`)
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsThreadAndConversationMap(id, payload) {
  if (isAuthenticated()) {
    return axios
      .post(`${constants.customerDomain}apps/${id}/settings`, payload)
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function updateSettings(id, post) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${id}/settings`, { settings: post })
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_NOT_FOUND'
        ) {
          notification.error({
            message: 'App Not Found!',
            description: error.response.data.error.message,
          })
        } else if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_ACCESS_DENIED'
        ) {
          notification.error({
            message: 'Access denied',
            description:
              'You are not authorized to change app settings. Please contact your app owner',
          })
        } else if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }

        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}
